import { provideHttpClient } from '@angular/common/http'
import {
    ApplicationConfig,
    inject,
    isDevMode,
    provideAppInitializer,
    provideZoneChangeDetection,
    ErrorHandler,
} from '@angular/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter } from '@angular/router'
import { provideServiceWorker } from '@angular/service-worker'
import { ApolloLink, InMemoryCache } from '@apollo/client/core'
import { BootService } from '@app-services/boot/boot.service'
import { provideApollo } from 'apollo-angular'
import { HttpLink } from 'apollo-angular/http'
import Pusher from 'pusher-js'
import { environment } from '../environment/environment'
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular'
import { routes } from './app.routes'
import { PusherLink } from './links/pusher.link'

export function errorHandlerFactory() {
    return new BugsnagErrorHandler()
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(),
        provideHttpClient(),
        {
            provide: ErrorHandler,
            useFactory: errorHandlerFactory
        },
        provideApollo(() => {
            const httpLink = inject(HttpLink)
            const uri = `${environment.api.schema}://${environment.api.host}/graphql`

            const pusherLink = new PusherLink({
                pusher: new Pusher(environment.pusher.key, {
                    cluster: environment.pusher.cluster,
                    authEndpoint: `${uri}/subscriptions/auth`,
                    auth: {
                        headers: {
                            authorization: environment.pusher.secret,
                        },
                    },
                }),
            })

            return {

                link: ApolloLink.from([
                    pusherLink,
                    httpLink.create({
                        uri,
                    }),
                ]),
                cache: new InMemoryCache(),
            }
        }),
        provideAppInitializer(() => {
            return inject(BootService).initialize()
        }),
        provideServiceWorker('ngsw-worker.js', {
            enabled: ! isDevMode(),
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
}
